import closeProjection from '../../../assets/images/baseAssets/close.png';

import Asset from '../BaseAssets';

const CloseAndGoToMainScreenLink = Asset.Link.withProps({
    projection: closeProjection,
    to: '/game/game-user',
    "data-testid": "back-to-main-screen-btn"
});

export default CloseAndGoToMainScreenLink;
